const settings = {
  btnSave: 'שמור',
  off: 'כבוי',
  btnRestoreDefault: 'שחזר הגדרות ברירת מחדל',

  btnAdvance: {
    show: 'הצג מתקדם',
    hide: 'הסתר מתקדם',
  },

  general: {
    title: 'כללי',
    pageTitle: 'הגדרות כלליות',
    groups: {
      general: {
        title: 'כללי',
        parameters: {
          timezone: {
            label: 'אזור זמן',
            description: 'המערכת',
          },
          defaultLanguage: {
            label: 'שפת ברירת מחדל',
            description: 'שפה מועדפת – תיושם כאשר מתבצעת מעבר תצוגת האתר, רענון או כניסה, אם לא מוגדרת שפה מועדפת למשתמש.',
          },
          systemType: {
            label: 'סוג מערכת',
            description: 'מעבר בין יחידות אימפריאליות למטריות להתאמה אישית של תצוגת מרחקים במערכת',
            options: {
              imperial: 'אימפריאלי',
              metric: 'מטרי',
            },
          },
          addressType: {
            label: 'סוג שדה כתובת',
            description: 'התאמה אישית של מילוי כתובות. "Google" מאפשרת מילוי אוטומטי מגוגל, "Location" ממלא מיקומים שמורים מהמערכת',
            options: {
              both: 'Both',
              google: 'Google',
              location: 'Location',
            },
          },
        },
      },
      auth: {
        title: 'אימות',
        parameters: {
          twoFA: {
            label: 'אכיפת אימות דו-שלבי (2FA)',
            description: 'כאשר אפשרות זו מופעלת, כל המשתמשים מחויבים לבצע אימות דו-שלבי במכשירים חדשים.',
          },
        },
      },
      booking: {
        title: 'הזמנה',
        parameters: {
          preventDuplications: {
            label: 'התראה על שכפול הזמנה',
            description: 'הפעלת אפשרות זו תאפשר קבלת התראה כאשר הזמנה עם פרטים זהים מתמלאת, או ביטול התראה זו.',
          },
          isWaitAndReturnEnabled: {
            label: 'אפשרות המתנה וחזרה',
            description: '',
          },
        },
      },
      map: {
        title: 'מפה',
        parameters: {
          mapServer: {
            label: 'שרת מפות',
            description: 'שרת מפות OSRM',
          },
          mapCenter: {
            label: 'מרכז המפה',
            description: 'הגדרת נקודת המרכז כברירת מחדל בתצוגת המפה',
          },
          mapZoom: {
            label: 'זום מפה',
            description: 'זום ברירת המחדל למפות בפלטפורמה',
          },
        },
      },
    },
  },
  routing: {
    title: 'ניווט',
    pageTitle: 'הגדרות ניווט',
    groups: {
      base: {
        title: 'בסיס',
        parameters: {
          sharedRideRatio: {
            label: 'יחס זמן משותף מקסימלי',
            description: 'היחס המרבי המותר בין זמן נסיעה יחיד לבין זמן נסיעה משותפת (לדוגמה 1.5 = עד 50% יותר מהנסיעה היחידה)',
          },
          sharedRideDifferenceLimit: {
            label: 'זמן נוסף מקסימלי לנסיעה משותפת',
            description: 'מספר הדקות המקסימלי שניתן להוסיף לזמן נסיעה יחיד כאשר הנוסע בנסיעה משותפת',
          },
          maxSharedDistanceRatio: {
            label: 'יחס מרחק משותף מקסימלי',
            description: 'מגדיר בכמה נסיעה משותפת יכולה להיות ארוכה יותר לעומת מרחק הנסיעה היחידנית. דוגמה: אם מרחק נסיעה יחיד הוא 1 מייל והיחס הוא 1.2x, הנסיעה המשותפת לא יכולה לעלות על 1.2 מייל',
          },
          maxTripStops: {
            label: 'מספר מקסימלי של עצירות',
            description: 'מספר מקסימלי של מיקומי עצירה לנסיעה',
          },
          maxPickupStops: {
            label: 'מספר מקסימלי של איסופים',
            description: 'מספר מקסימלי של נקודות איסוף לנסיעה',
          },
          maxDropoffStops: {
            label: 'מספר מקסימלי של הורדות',
            description: 'מספר מקסימלי של נקודות הורדה לנסיעה',
          },
          maxTripDuration: {
            label: 'משך זמן מקסימלי',
            description: 'משך זמן מקסימלי של נסיעה בדקות',
          },
          maxSinglePassengerTime: {
            label: 'זמן נסיעה מקסימלי לנוסע יחיד',
            description: '',
          },
          maxPassengers: {
            label: 'מספר מקסימלי של נוסעים',
            description: 'מספר מקסימלי של נוסעים לכל הנסיעה',
          },
          maxPassengersAtOnce: {
            label: 'מספר מקסימלי של נוסעים בבת אחת',
            description: 'מספר מקסימלי של נוסעים שמותר להם להיות באותו הזמן (מושב יתפנה/יתמלא על פי הורדה/איסוף).',
          },
          tripBoardingTime: {
            label: 'זמן עלייה',
            description: 'משך הזמן הדרוש לאיסוף נוסע בנקודת העצירה שלו (פרמטר זה ישפיע על זמן הנסיעה הכולל)',
          },
          subsequentPickTime: {
            label: 'זמן עלייה משני',
            description: 'כאשר הגדרה זו כבויה, זמני העלייה מתאימים לכלל.',
          },
          tripDropOffTime: {
            label: 'זמן הורדה',
            description: 'משך הזמן הדרוש להורדת נוסע בנקודת העצירה שלו (פרמטר זה ישפיע על זמן הנסיעה הכולל).',
          },
          subsequentDropOffTime: {
            label: 'זמן הורדה משני',
            description: 'כאשר הגדרה זו כבויה, זמני ההורדה מתאימים לכלל.',
          },
          maxBoardingDelay: {
            label: 'עיכוב מקסימלי בעלייה',
            description: 'מספר מקסימלי של דקות שבהן הנהג יכול לאחר לזמן האיסוף שהוגדר בהזמנה.',
          },
          maxBoardingEarly: {
            label: 'הקדמה מקסימלית בעלייה',
            description: 'מספר מקסימלי של דקות שבהן הנהג יכול להקדים ביחס לזמן האיסוף שהוגדר בהזמנה.',
          },
          onlyPrivate: {
            label: 'פרטי בלבד',
            description: 'הפוך את כל הנסיעות לפרטיות',
          },
        },
      },
      advanced: {
        title: 'מתקדם',
        parameters: {
          tripsJoinMode: {
            label: 'ניסיון חיבור',
            description: 'החליט אם המנוע ינסה לחבר הזמנות חדשות לנסיעות קיימות: DontJoin = 0, TryJoin = 1, OnlyJoin = 2',
            options: {
              dontJoin: 'אל תאחד',
              tryJoin: 'נסה לאחד',
              onlyJoin: 'אחד בלבד',
            },
          },
          maxJoinRadius: {
            label: 'ניסיון חיבור - רדיוס',
            description: 'מגדיר את הרדיוס המקסימלי שבו ננסה לחפש נסיעות קיימות לחיבור הזמנה.',
          },
          maxJoinTimeRange: {
            label: 'ניסיון חיבור - טווח זמן',
            description: 'נסיעות קיימות שמעבר למגבלה זו ייחשבו לניסיון חיבור.',
          },
          maxReservationsAtOnce: {
            label: 'מספר מקסימלי של הזמנות בו-זמנית',
            description: 'מספר מקסימלי של הזמנות שמותר שיהיו ברכב בו-זמנית.',
          },
          minReservationDistance: {
            label: 'מרחק מינימלי להזמנה',
            description:
              'מרחק מינימלי (במטרים) שצריך להיות להזמנה בין מיקום האיסוף להורדה כדי להיכלל בנתיב. הזמנות עם מרחק קטן מזה ייתעלמו לחלוטין על ידי המנוע.',
          },
          maxEmptyTripTime: {
            label: 'זמן ריק מקסימלי',
            description: 'מספר מקסימלי של דקות שבהן מותר לנסיעה להיות ריקה בין עצירות.',
          },
          maxDropOffEarly: {
            label: 'הקדמה מקסימלית בהורדה',
            description: 'מספר מקסימלי של דקות שבהן הנהג יכול להקדים ביחס לזמן ההורדה שהוגדר בהזמנה.',
          },
          maxDropOffDelay: {
            label: 'עיכוב מקסימלי בהורדה',
            description: 'מספר מקסימלי של דקות שבהן הנהג יכול לאחר לזמן ההורדה שהוגדר בהזמנה.',
          },
          pickPhaseRadius: {
            label: 'טווח רדיוס איסוף',
            description:
              'מגדיר את המרחק המקסימלי המותר (בקילומטרים או מיילים) בין האיסוף הראשון לאיסופים הבאים. הזמנות עם איסופים מחוץ לרדיוס זה לא יאוחדו.',
          },
          pickPhaseMinutes: {
            label: 'טווח דקות איסוף',
            description:
              'מגדיר את הזמן המקסימלי (בדקות) המותר בין האיסוף הראשון לאיסופים הבאים. אם הפרש הזמן חורג מסף זה, ההזמנות לא יאוחדו.',
          },
          groupWaitAndReturn: {
            label: 'קיבוץ המתנה וחזרה',
            description:
              '• כבוי: אין קיבוץ כלל; נסיעות יוצאות ונסיעות חזרה מנותבות בנפרד.\n\n• זוג בודד: קבוצת כל נסיעה יוצאת וחזרה יחד בנסיעה אחת.\n\n • זוגות מרובים: קיבוץ זוגות מרובים של נסיעות יוצאות וחוזרות יחד, המאפשר ריבוי זוגות המתנה וחזרה במסלול אחד.',
            options: {
              off: 'כבוי',
              individualPair: 'קיבוץ זוגות בודדים',
              multiplePairs: 'קיבוץ זוגות מרובים',
            },
          },
          pickupAllBeforeDropping: {
            label: 'איסוף כולם',
            description: 'כאשר מוגדר כ-True, הנסיעה תאסוף את כל הנוסעים תחילה ואז תתחיל להוריד את כולם.',
          },
          waitForBoardingTime: {
            label: 'המתנה לזמן העלייה',
            description: 'כאשר מגיעים לעצירה, הנהג ימתין עד לזמן האיסוף המדויק, אם נדרש.',
          },
          sortStopsByPickupTime: {
            label: 'מיון לפי זמן איסוף',
            description: 'כאשר מוגדר כ-True, כל העצירות במסלול ימוינו לפי זמן האיסוף בלבד ולא גיאוגרפית.',
          },
          balanceDepartureTime: {
            label: 'נרמול יציאה',
            description: 'מתאים את זמן היציאה כך שנוסעים',
          },
          angleDuration: {
            label: 'משך זמן זווית',
            description: 'נמנע מניווט חלקי מסלול שמשך הזמן שלהם גדול ממשך זמן הזווית ובזווית מעל זווית מסוימת.',
          },
          angleMax: {
            label: 'זווית מקסימלית',
            description: 'נמנע מניווט חלקי מסלול שמשך הזמן שלהם גדול ממשך זמן הזווית ובזווית מעל זווית מסוימת.',
          },
          allowActiveTripsRouteChanges: {
            label: 'הוסף הזמנות לנסיעות בדרך',
            description: 'אפשר הזמנות \'ניסיון הצטרפות\' (לדוגמה, שיחות לפי דרישה) לנסיעות בדרך לצד נסיעות חדשות.',
          },
          vrpRunningTime: {
            label: 'זמן ריצה של VRP',
            description: 'מגבלת זמן לאופטימיזציה לנסות ולשפר את התוצאות; ריצה ארוכה יותר מאפשרת לחקור אפשרויות נוספות.',
          },
          editOnMap: {
            label: 'ערוך על המפה',
            description: 'מאפשר למשתמשים לסדר מחדש תחנות בנסיעה על ידי גרירה במפה.',
          },
          consistentPassengerRouting: {
            label: 'ניתוב נוסעים עקבי',
            description: 'מבטיח שקבוצת הנוסעים תיסע תמיד באותו מסלול אל הכתובת הספציפית וממנה, לשיפור היעילות ולהפחתת בלבול.',
          },
          sameDriverForGroup: {
            label: 'אותו נהג לקבוצה',
            description: 'מקצה את אותו נהג להסעת קבוצת הנוסעים גם לאיסוף וגם להורדה, לצורך היכרות ועקביות',
          },
          routingMode: {
            label: 'מצב ניתוב',
            description: '',
            options: {
              default: 'ברירת מחדל',
              hClustering: 'H-Clustering',
              vrp: 'VRP',
            },
          },
          defaultWillCallTime: {
            label: 'סטיית זמן ברירת מחדל של Will Call (בדקות)',
            description: 'הוסף X דקות ללוגיקת סטיית הזמן של Will Call כברירת מחדל כאשר אין מאפיין הקשור ל-Will Call',
          },
          enableWillCallTime: {
            label: 'זמן Will Call פעיל',
          },
        },
      },
      sameAreaLocation: {
        title: 'אותו אזור / מיקום',
        parameters: {
          mergeReservationsByBoardingArea: {
            label: 'אזור איסוף זהה',
            description: 'הזמנות יוקבצו יחד רק אם מיקום האיסוף נמצא באותו פוליגון.',
          },
          mergeReservationsByBoardingLocation: {
            label: 'מיקום איסוף זהה',
            description: 'הזמנות יוקבצו יחד רק אם מיקום האיסוף זהה.',
          },
          mergeReservationsByDropArea: {
            label: 'אזור הורדה זהה',
            description: 'הזמנות יוקבצו יחד רק אם מיקום ההורדה נמצא באותו פוליגון.',
          },
          mergeReservationsByDropLocation: {
            label: 'מיקום הורדה זהה',
            description: 'הזמנות יוקבצו יחד רק אם מיקום ההורדה זהה.',
          },
          onlyGroupExactLocations: {
            label: 'מיקום איסוף או הורדה זהה',
            description: 'הזמנות יוקבצו יחד רק אם מיקומי האיסוף או ההורדה זהים.',
          },
          snapToLocation: {
            label: 'התאמה למיקום',
            description:
              'התאמה אוטומטית של מיקום התחלה או יעד להזמנה למיקום הקרוב ביותר שנמצא במודול ניהול המיקומים שלנו, אם הוא בטווח רדיוס ההתאמה.',
          },
          sameFlightNumber: {
            label: 'אותו מספר טיסה',
            description: 'הזמנות יקובצו יחד רק אם מספר הטיסה זהה.',
          },
        },
      },
      evs: {
        title: 'כלי רכב חשמליים',
        parameters: {
          minimalBatteryThreshold: {
            label: 'סף סוללה מינימלי',
            description:
              'אחוז סוללה קריטי שהמערכת לא תרד מתחתיו במהלך נסיעתך. לדוגמה, אם מוגדר על 30%, המערכת תשאף לשמור את הסוללה מעל רמה זו.',
          },
        },
      },
      reservationClusters: {
        title: 'קיבוץ הזמנות',
        parameters: {
          isClusteringEnabled: {
            label: 'קיבוץ',
            description: 'מגדיר אם אלגוריתמי קיבוץ ההזמנות פעילים או לא.',
          },
          clusterSnapTo: {
            label: 'מצב',
            description: 'מגדיר אם יש לשנות כתובת מרכז האשכול לדרך מוכרת או תחנת אוטובוס.',
            options: {
              address: 'כתובת',
              busStop: 'תחנת אוטובוס',
            },
          },
          clusterReservationsRadius: {
            label: 'קוטר',
            description: 'באיזה קוטר להתחיל לשלב הזמנות יחד לנקודת איסוף/הורדה אחת.',
          },
          clusterSnapMaxDistance: {
            label: 'מרחק מקסימלי',
            description: 'המרחק המקסימלי (בק"מ/מיילים לפי המערכת שהוגדרה) שבו ניתן לשנות את כתובת מרכז האשכול למיקום טוב יותר.',
          },
          snapToShapeRatio: {
            label: 'תחנות/אשכולות עדיפות לפי מרחק אווירי',
            description: 'המערכת תנסה ליצור תחנות נוספות לאורך המסלול אם המרחק האווירי של הנוסע קצר מהיחס שנבחר.',
          },
          snapToShapeUnite: {
            label: 'מרחק מינימלי בין התחנות שנוצרו',
            description: 'מרחק מינימלי בין התחנות שנוצרו.',
          },
          distanceType: {
            label: 'סוג מרחק',
            description: 'מגדיר אם המרחק אל האשכול יימדד לפי מרחק אווירי או לפי מרחק הליכה',
            options: {
              airDistance: 'מרחק אווירי',
              walkingDistance: 'מרחק הליכה',
            },
          },
          maxPassengersInCluster: {
            label: 'מספר נוסעים מקסימלי באשכול',
            description: 'מספר הנוסעים המרבי המותר באשכול. ההגדרה נשארת ניתנת לעריכה גם כאשר הקיבוץ כבוי.',
          },
          keepVrpClusters: {
            label: 'שמור אשכולות VRP',
            description: 'כאשר מופעל, פלט ה-VRP נשאר מקובץ. כאשר כבוי, אשכולות ה-VRP מפוצלים להזמנות בודדות לניתוב מחדש.',
          },
        },
      },
      smoothRoute: {
        title: 'מסלול חלק',
        parameters: {
          smoothRouteEnabled: {
            label: 'מסלול חלק',
            description: 'מגדיר אם כתובת מרכז האשכול תשתנה לכתובת של כביש ידוע, תחנת אוטובוס או לפי מסלול חלק',
          },
          smoothRouteRadius: {
            label: 'רדיוס מסלול חלק',
            description:
              'מגדיר את מרחק ההליכה המרבי (במטרים) שנוסע עשוי להידרש ללכת כאשר "מסלול חלק" מופעל. הגדרה זו נכנסת לתוקף רק אם "מסלול חלק" מופעל',
          },
        },
      },
      traffic: {
        title: 'תנועה',
        parameters: {
          trafficRouteEnabled: {
            label: 'עריכת הגדרות תנועה',
            modalHeader: 'אזהרה: הגדרות תנועה רגישות',
            modalBody:
              'אתה עומד לערוך הגדרות מתקדמות של תנועה. הערכים הללו משפיעים ישירות על חישוב המסלולים ועלולים לשנות באופן משמעותי את התנהגות המערכת. אנא המשך רק אם אתה מבין את המשמעויות במלואן. כדי לאשר, הקלד "traffic" למטה ולחץ על "אישור".',
          },
          minTraffic: {
            label: 'מינימום',
            description: 'יחס מינימלי בין משך זמן התנועה למשך זמן שרת המפות',
          },
          baseTraffic: {
            label: 'בסיס',
            description: 'כפול את כל משכי הזמן המחושבים לפי יחס בסיס (X). ערכים גבוהים יותר מאריכים את זמני הנסיעה המשוערים.',
          },
          hourTraffic: {
            label: 'שעה',
            description: 'מערך של 24 יחסי שעות (00:00–23:59). כל ערך מתאים את מכפיל משך הנסיעה בהתאם לשעת היום.',
          },
        },
      },
    },
  },
  assignment: {
    title: 'שיוך נהגים',
    pageTitle: 'הגדרות שיוך נהגים',
    groups: {
      base: {
        title: 'בסיס',
        parameters: {
          distanceFromTripScore: {
            label: 'מרחק',
            description: 'תן עדיפות גבוהה יותר אם ברצונך להגדיל את הסיכוי שהנהג הקרוב ביותר לנסיעה יוקצה.',
          },
          timeFromTripScore: {
            label: 'זמן',
            description: 'תן עדיפות גבוהה יותר אם ברצונך להגדיל את הסיכוי שהנהג שיכול להגיע הכי מהר לנקודת ההתחלה יוקצה.',
          },
          gapTimeScore: {
            label: 'זמן המתנה',
            description: 'עדיפות גבוהה יותר תגדיל את הסיכוי שנהג שממתין לעבודה הבאה שלו הכי הרבה זמן יוקצה.',
          },
          assignedTripsScore: {
            label: 'מספר נסיעות',
            description:
              'ככל שהעדיפות גבוהה יותר, כך גדל הסיכוי שמי שכבר הוקצה יוקצה שוב. תן עדיפות נמוכה יותר לאיזון הנסיעות בין נהגים פעילים ועדיפות גבוהה יותר למינימום נהגים הכרחיים.',
          },
          accumulatedSalaryScore: {
            label: 'רווחים',
            description:
              'תן עדיפות גבוהה אם ברצונך לאזן את כמות הנהגים על בסיס שכרם (שימוש במספר הנהגים הגבוה ביותר). תן עדיפות נמוכה אם ברצונך להשתמש במינימום נהגים.',
          },
          algorithmCode: {
            label: 'קוד אלגוריתם',
            options: {
              dateOrdering: 'סידור לפי תאריך',
              dynamicOrdering: 'סידור דינמי',
            },
          },
          driverAssignmentStrategy: {
            label: 'אסטרטגיית הקצאת נהגים',
            options: {
              minimumFleetUsage: 'שימוש מינימלי בצי הרכב',
              balanceAvailableDrivers: 'איזון – נהגים זמינים',
              balanceMinimumRequiredDrivers: 'איזון – נהגים מינימליים נדרשים',
            },
          },
        },
      },
      limits: {
        title: 'מגבלות',
        parameters: {
          maxTripsPerDriver: {
            label: 'מספר נסיעות מקסימלי',
            description: 'מספר מקסימלי של נסיעות שנהג יכול להיות מוקצה להן בבקשה נתונה.',
          },
          maxAccumulatedSalary: {
            label: 'מחיר מקסימלי',
            description: 'סכום מקסימלי של שכר שיכול נהג להרוויח בתהליך ההקצאה (ואז נהגים אחרים יקבלו עדיפות).',
          },
        },
      },
      advanced: {
        title: 'הגדרות מתקדמות',
        parameters: {
          distanceFromHomeScore: {
            label: 'מרחק מהבית',
            description: 'אם ברצונך לשמור את הנהגים קרוב לביתם (נקודת ההתחלה שלהם), עליך לתת עדיפות גבוהה.',
          },
          nextTripDistanceScore: {
            label: 'מרחק מהנסיעה הבאה',
            description: 'כאשר אנו "ממלאים חורים" בלוח הזמנים של הנהג, תעדף לפי מרחק הנסיעה הבאה.',
          },
          idleBonusMinutes: {
            label: 'בונוס זמן המתנה (בדקות)',
            description: 'תקופת זמן שהנהג צריך להמתין כדי לקבל את הבונוס',
          },
          idleBonusScore: {
            label: 'ניקוד בונוס על זמן המתנה',
            description: 'כמות הנקודות שנוספת לציון הנהג לאחר זמן המתנה של ${} דקות.',
          },
          scorePerEmptySeats: {
            label: 'לכל מושב ריק',
            description: 'השתמש בהגדרה זו כדי לציין את העדפתך למזעור מושבים ריקים ברכב (ככל שהערך שלילי יותר, כך ההימנעות חזקה יותר).',
          },
          assignPriorityBonusMax: {
            label: 'בונוס עדיפות לכללים מותאמים – מקסימום',
            description: 'הציון המרבי המוענק למאפיין בעל העדיפות הגבוהה ביותר בעת הקצאת נסיעות',
          },
          assignPriorityBonusMin: {
            label: 'בונוס עדיפות לכללים מותאמים – מינימום',
            description: 'הציון המזערי המוענק למאפיין בעל העדיפות הנמוכה ביותר בעת הקצאת נסיעות',
          },
          areaMatchScore: {
            label: 'התאמה לפי אזור',
            description: 'ככל שהעדיפות גבוהה יותר, כך גדל הסיכוי שנהג ששייך לאזור הנסיעה יוקצה.',
          },
          scorePerVehicleCost: {
            label: 'עלות לכל רכב',
            description: '',
          },
          perAssignmentScore: {
            label: 'ניקוד לכל הקצאה',
            description: 'מוסיף ניקוד עבור כל נסיעה שהוקצתה לנהג. ערכים גבוהים יותר ירתיעו מהקצאת מספר נסיעות לאותו נהג.',
          },
          perLoadedDistance: {
            label: 'ניקוד למרחק טעון',
            description: 'מוסיף ניקוד על בסיס מרחק הנסיעות עם נוסעים (מיילים טעונים). ערכים גבוהים יותר מעדיפים נסיעות קצרות יותר ומפחיתים את סך המרחק הטעון.',
          },
          isAssignBlocked: {
            label: 'חסימת הקצאה אוטומטית',
            description: 'כאשר הקצאה אוטומטית כבויה, פרופילים נבחרים לא יוקצו באופן אוטומטי.',
          },
          assignBlockedProfiles: {
            label: 'פרופילים חסומים',
            description: 'בחר אילו פרופילים לא יוקצו באופן אוטומטי על ידי הפלטפורמה.',
          },
          assignBlockedAttributes: {
            label: 'מאפיינים חסומים',
            description: 'בחר אילו מאפיינים לא יוקצו באופן אוטומטי על ידי הפלטפורמה.',
          },
          allowFlexibleTimes: {
            label: 'אפשר זמנים גמישים',
            description:
              'אופטימיזציה להקצאת נהגים והפחתת שימוש ברכבים על ידי שינוי זמני יציאה לנסיעה, תוך עמידה בחוקי עיכוב והקדמה מקסימליים.',
          },
          unassignOnVehicleChange: {
            label: 'בטל את הסרת שיוך הנהג בעת שינוי רכב',
            description: 'שינוי נהג לרכב אחר עם מאפיינים תואמים של "התאמת מאפייני הזמנה נהג/רכב" לא יסיר באופן אוטומטי את שיוך הנסיעה של הנהג.',
          },
          consistentSupplier: {
            label: 'ספק עקבי',
            description: 'המערכת תשבץ נהגים מאותו ספק לכל ההזמנות של הנוסע באותו יום, תוך התעלמות ממגבלות הנהגים.'
          },
          assignBySupplier: {
            label: 'שיבוץ לפי ספק',
            description: '',
          },
          supplierPriorityMode: {
            label: 'סדר ספקים',
            description: '',
            options: {
              byRank: 'לפי דירוג',
              byTier: 'לפי שכבה / רמה'
            }
          },
          shiftAllocationWeight: {
            label: 'זמינות נהג',
            description: 'מספר הנקודות שנוספות לציון הנהג לפי משך המשמרת',
          }
        },
      },
      driverShifts: {
        title: 'משמרות נהגים',
        parameters: {
          ignoreDriverShifts: {
            label: 'התעלמות ממשמרות הנהגים',
            description: 'תהליך הקצאת הנהגים מתחשב במשמרות הנהגים.',
          },
          startShiftWithTrip: {
            label: 'התחלת משמרת עם נסיעה',
            description:
              'מקצה נהגים לנסיעות בתחילת המשמרת שלהם מבלי להתחשב בזמן הנסיעה לאיסוף הראשון. הנהגים אחראים להגיע למיקום האיסוף ההתחלתי בזמן.',
          },
          maxShiftHours: {
            label: 'משך מקסימלי למשמרת',
            description: 'אורך מקסימלי (בשעות) למשמרת נהג. המנוע לא יאפשר שנהג ייחשב פעיל מעבר לזמן זה.',
          },
          shiftGap: {
            label: 'מרווח בין משמרות',
            description: 'הגדר את משך הפסקת החובה בין משמרות רצופות.',
          },
          driverRestAfterTrip: {
            label: 'אכיפת הפסקה',
            description: 'נהגים מתבקשים לקחת מנוחה לאחר כל נסיעה.',
          },
        },
      },
      mobileApp: {
        title: 'אפליקציית משמרות נהגים',
        parameters: {
          allowShiftCreation: {
            label: 'אפשר יצירת משמרות',
            description: 'אפשר לנהגים ליצור משמרות חדשות בלוח הזמנים שלהם.',
          },
          allowBreaksInShifts: {
            label: 'אפשר הפסקות במשמרות',
            description: 'אפשר לנהגים לכלול הפסקות בתוך המשמרות שלהם.',
          },
          enableShiftDeletion: {
            label: 'אפשר מחיקת משמרות',
            description: 'אפשר לנהגים למחוק את המשמרות המתוכננות שלהם במידת הצורך.',
          },
          minimumShiftCancellationNotice: {
            label: 'הודעה מוקדמת מינימלית לביטול משמרת',
            description: 'הגדר את הזמן המינימלי הנדרש לפני תחילת המשמרת כדי שהנהג יוכל לבטלה.',
          },
          maxShiftAvailability: {
            label: 'זמינות משמרת מרבית',
            description: 'הגדר את משך הזמן המרבי של זמינות שהנהג יכול להגדיר לעצמו.',
          },
          enableRecurringShifts: {
            label: 'אפשר משמרות חוזרות',
            description: 'אפשר לנהגים ליצור משמרות חוזרות בטווח תאריכים מותאם אישית.',
          },
        },
      },
      virtualReal: {
        title: 'וירטואלי לעומת אמיתי',
        parameters: {
          assignmentType: {
            label: 'סוג הקצאה',
            description: 'מצב ההקצאה ברירת מחדל (נהגים בפועל לעומת נהגים וירטואליים).',
            options: {
              virtual: 'וירטואלי',
              real: 'אמיתי',
            },
          },
          addVirtualDrivers: {
            label: 'מילוי עם נהגים וירטואליים',
            description: 'הקצאה אוטומטית של נהגים וירטואליים לנסיעות כאשר אין זמינות של נהגים בפועל.',
          },
          defaultCarLocation: {
            label: 'מיקום רכב ברירת מחדל',
            description: 'מיקום התחלה ברירת מחדל שיש לקחת בחשבון עבור רכב/נהג אם לא צוין אחרת.',
          },
          defaultCarSeats: {
            label: 'מושבים ברירת מחדל',
            description: 'מספר מושבים ברירת מחדל שיש לקחת בחשבון לרכב אם לא הוגדר.',
          },
        },
      },
    },
  },
  distribution: {
    title: 'הפצה',
    pageTitle: '',
    groups: {
      base: {
        title: 'משקל מדדי ביצוע של צי רכבים',
        parameters: {
          onTimePerformance: {
            label: 'עמידה בזמנים',
            description: '',
          },
          noShowRate: {
            label: 'שיעור אי הגעה',
            description: '',
          },
          cancellationRate: {
            label: 'שיעור ביטולים',
            description: '',
          },
          acceptanceRate: {
            label: 'שיעור קבלה',
            description: '',
          },
          responseTime: {
            label: 'זמן תגובה',
            description: '',
          },
          costEfficiency: {
            label: 'יעילות עלות',
            description: '',
          },
        },
      },
    },
  },
  advancedSettingsPopups: {
    maxDurationByDistance: {
      title: 'הגדר משך מרבי לפי מרחק',
      form: {
        fields: {
          startKm: '({{unit}})-מ',
          endKm: '({{unit}})-עד',
          durationMinutes: 'משך מרבי (דקות)',
        },
        btnAddRange: 'הוסף טווח',
        btnSubmit: 'שמור',
        btnClose: 'סגור',
      },
    }
  }
};

export default settings;
